/*
 * @Author: Dong
 * @Date: 2022-04-25 17:24:23
 * @LastEditors: zhang lin
 * @LastEditTime: 2022-11-04 15:17:16
 */
import React from 'react';
import { useIntl } from 'react-intl';
import messages from './messages';
import styles from './index.less';
import empty from 'root/assets/images/illustrator_empty.svg';

const NoSupos = () => {
  const intl = useIntl();

  return (
    <div className={styles.container}>
      <img src={empty} className={styles.emptyImg} />
      <span className={styles.tip1}>
        {intl.formatMessage(messages.noSupos1)}&quot;
        <i
          onClick={() => {
            window.location.href = '#/packageManage';
          }}
        >
          {intl.formatMessage(messages.package)}
        </i>
        &quot;
        {intl.formatMessage(messages.noSupos3)}
      </span>
      <span className={styles.tip2}>{intl.formatMessage(messages.noSupos2)}</span>
      <span className={styles.btn}>{intl.formatMessage(messages.installSupos)}</span>
    </div>
  );
};

export default NoSupos;
